import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Col, Divider, Row } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import CardAboutMe from '../../components/card-about-me';
import styles from './DownLineCollab.module.scss';
import collabAPI from '~/api/CollabAPI';
import { getNumberWithCommas } from '~/utils';
import moment from 'moment';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { useNavigate } from 'react-router';
import { LeftOutlined } from '@ant-design/icons';
import config from '~/config';

const cx = classNames.bind(styles);

const DownLineCollab = () => {
    const navigate = useNavigate();
    const [showAmount, setShowAmount] = useState(false);

    const [wallet, setWallet] = useState(0);

    const [downLineCollabList, setDownLineCollabList] = useState([]);

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 100,
        total_item: 0,
        total_page: 0,
    });

    const handleSeeMore = () => {
        try {
            const nextPage = pagination.page + 1;
            handleGetListCollab(downLineCollabList, nextPage);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        handleGetListCollab(downLineCollabList, pagination.page);
        // eslint-disable-next-line
    }, []);

    const handleGetListCollab = async (list, page) => {
        try {
            const collabs = list;
            let final = [];
            const params = {
                fields: '["$all"]',
                limit: pagination.limit,
                page: page,
            };
            const res = await collabAPI.getListDownLineCollabAPI(params);

            if (res.code === 200) {
                collabs.push(...res.results.objects.rows);
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.objects.count,
                    total_page: Math.ceil(res.results.objects.count / res.pagination.limit),
                });
            }
            if (collabs?.length) {
                final = [...new Map(collabs.map((item) => [item['id'], item])).values()];
            }
            setWallet(res.results.objects?.total_bonus_rose_of_parent);
            setDownLineCollabList(final);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangDanhSachCTVTuyenDuoi');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('left_section')}>
                    <div className={cx('left_wrapper')}>
                        <div className={cx('left_container')}>
                            <Row>
                                <CardAboutMe tabIndex={{ parent: 5, children: 0 }} />
                            </Row>
                        </div>
                    </div>
                </div>
                <div className={cx('title_header')}>
                    <Row className={cx('title_header_row')}>
                        <p className={cx('title')}>
                            <LeftOutlined
                                onClick={() => navigate(config.routes.personalPage)}
                                className={cx('btn_back')}
                            />{' '}
                            List of downline collaborators
                        </p>
                        <>
                            {showAmount ? (
                                <EyeOutlined className={cx('icon_show_amount')} onClick={() => setShowAmount(false)} />
                            ) : (
                                <EyeInvisibleOutlined
                                    className={cx('icon_show_amount')}
                                    onClick={() => setShowAmount(true)}
                                />
                            )}
                        </>
                    </Row>
                </div>
                <div className={cx('right_section')}>
                    <Row className={cx('name_page')}>
                        <Col xs={20}>List of downline collaborators</Col>
                        <Col xs={4}>
                            <Row justify="end">
                                {showAmount ? (
                                    <EyeOutlined
                                        className={cx('icon_show_amount')}
                                        onClick={() => setShowAmount(false)}
                                    />
                                ) : (
                                    <EyeInvisibleOutlined
                                        className={cx('icon_show_amount')}
                                        onClick={() => setShowAmount(true)}
                                    />
                                )}
                            </Row>
                        </Col>
                    </Row>
                    <div className={cx('right_container')}>
                        <Row justify="center">
                            <div className={cx('tab_wallet_withdraw')}>
                                <img src={SVGS.IconWalletTabAmount} alt="" />
                                <div className={cx('name_wallet')}>Total Revenue</div>
                                <div className={cx('amount_wallet')}>
                                    {showAmount ? `${getNumberWithCommas(wallet || 0)} d` : '**********'}
                                </div>
                            </div>
                        </Row>
                        <Divider style={{ borderTop: '5px solid rgba(0,0,0,.06)' }} />
                        <Row className={cx('table_container')} justify="center">
                            {downLineCollabList?.length ? (
                                downLineCollabList?.map((item, index) => {
                                    return (
                                        <Row className={cx('item')} key={index}>
                                            <Col xs={6}>
                                                <Row justify="center">
                                                    <img
                                                        src={IMAGES.ImagePlaceholder}
                                                        alt=""
                                                        style={{ width: '100px' }}
                                                    />
                                                </Row>
                                            </Col>
                                            <Col xs={18}>
                                                <Row className={cx('phone')}>
                                                    {item?.phone}
                                                    {item?.fullname ? ` (${item?.fullname})` : ''}
                                                </Row>
                                                <Row>
                                                    Total commission received:
                                                    {getNumberWithCommas(Number(item?.bonus_rose_of_parent))}
                                                </Row>
                                                <Row>
                                                    Join date:
                                                    <span style={{ fontWeight: '600' }}>
                                                        {moment(
                                                            new Date(parseInt(item.created_at_unix_timestamp)),
                                                        ).format('DD/MM/YYYY HH:mm')}
                                                    </span>
                                                </Row>
                                            </Col>
                                        </Row>
                                    );
                                })
                            ) : (
                                <span>No downline collaborators</span>
                            )}
                        </Row>
                        {pagination.page < pagination.total_page && (
                            <Row justify="center" style={{ marginTop: '30px' }}>
                                <div className={cx('btn_see_more')} onClick={handleSeeMore}>
                                    see more
                                </div>
                            </Row>
                        )}
                        <Divider style={{ borderTop: '5px solid rgba(0,0,0,.06)' }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DownLineCollab;
